<template>
  <v-expansion-panel>
    <v-expansion-panel-header>
      <div>
        <v-icon>mdi-fire</v-icon><span class="headerTitle">{{ labels.fireTitle }}</span>
      </div>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-card>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.bldgNo }}</v-subheader>
                <span class="queryValue" v-if="fireForm.bldgNo">{{ fireForm.bldgNo }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.unitNo }}</v-subheader>
                <span class="queryValue" v-if="fireForm.unitNo">{{ fireForm.unitNo }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.collNo }}</v-subheader>
                <span class="queryValue" v-if="fireForm.collNo">{{ fireForm.collNo }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">{{ labels.interest }}</v-subheader>
                <v-textarea v-model="fireForm.interest" :rows="2" readonly />
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">{{ labels.riskLoc }}</v-subheader>
                <v-textarea v-model="fireForm.riskLoc" :rows="3" readonly />
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.riskPostCode }}</v-subheader>
                <span class="queryValue" v-if="fireForm.riskPostCode">{{ fireForm.riskPostCode }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.occpy }}</v-subheader>
                <span class="queryValue" v-if="fireForm.occpy">{{ fireForm.occpy }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.occpCls }}</v-subheader>
                <span class="queryValue" v-if="fireForm.occpCls">{{ fireForm.occpCls }} - {{ fireForm.occpClsDesc }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.distCls }}</v-subheader>
                <span class="queryValue" v-if="fireForm.distCls">{{ fireForm.distCls }} - {{ fireForm.distClsDesc }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.constnCls }}</v-subheader>
                <span class="queryValue" v-if="fireForm.constnCls">{{ fireForm.constnCls }} - {{ fireForm.constnClsDesc }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.occpClsLim }}</v-subheader>
                <span class="queryValue" v-if="fireForm.occpClsLim">{{ fireForm.occpClsLim }} - {{ fireForm.occpClsLimDesc }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.accmLdgPct }}</v-subheader>
                <span class="queryValue" v-if="fireForm.accmLdgPct">{{ fireForm.accmLdgPct }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md4 xs12 v-if="!polMaster.dri">
                <v-subheader class="queryLabel">{{ labels.zoneCode }}</v-subheader>
                <span class="queryValue" v-if="fireForm.zoneCode">{{ fireForm.zoneCode }} - {{ fireForm.zoneCodeDesc }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md4 xs12 v-if="!polMaster.dri">
                <v-subheader class="queryLabel">{{ labels.siLim }}</v-subheader>
                <span class="queryValue" v-if="fireForm.siLim">{{ fireForm.siLim }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
            </v-layout>
            <v-divider />
            <v-layout row wrap>
              <v-flex xs12>
                <v-subheader class="queryLabel">{{ labels.extraRiskLoc }}</v-subheader>
                <v-textarea v-model="fireForm.extraRiskLoc" :rows="4" readonly></v-textarea>
              </v-flex>
            </v-layout>
            <v-divider />
            <v-layout row wrap>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.ownTent }}</v-subheader>
                <span class="queryValue" v-if="fireForm.ownTent">{{ formatOwnTent(fireForm.ownTent) }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.roof }}</v-subheader>
                <span class="queryValue" v-if="fireForm.roof">{{ fireForm.roof }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.noStorey }}</v-subheader>
                <span class="queryValue" v-if="fireForm.noStorey">{{ fireForm.noStorey }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.latitude }}</v-subheader>
                <span class="queryValue" v-if="fireForm.latitude">{{ fireForm.latitude }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.longitude }}</v-subheader>
                <span class="queryValue" v-if="fireForm.longitude">{{ fireForm.longitude }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.survRpt }}</v-subheader>
                <span class="queryValue" v-if="fireForm.survRpt">{{ fireForm.survRpt }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.survDate }}</v-subheader>
                <span class="queryValue" v-if="fireForm.survDate">{{ formatDate(fireForm.survDate) }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md4 xs12 v-if="survRptDetDisabled">
                <a class="text-link" @click="doQueryRiskSurvey">Survey Report Details</a>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-dialog v-model="processing" persistent width="300">
          <v-card color="primary" dark>
            <v-card-text>
              Processing...
              <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog v-model="showRiskSurvey" width="1200px" persistent>
          <RiskSurvey @close="showRiskSurvey = false"></RiskSurvey>
        </v-dialog>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { formatDisplayDate } from '@/utils/date'
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import { RISK_SURVEY_QUERY_MODE } from '@/store/types'
import RiskSurvey from '@/components/core/underwriting/policy/riskSurveyDet/RiskSurveyDet'
import { formatPrice } from '@/utils/index'

export default {
  data() {
    return {
      labels: {
        fireTitle: 'Fire Risk Details',
        bldgNo: 'Block / House No.',
        unitNo: 'Unit No',
        collNo: 'Collateral No.',
        interest: 'Interest',
        riskLoc: 'Location',
        riskPostCode: 'Postal Code',
        occpy: 'Occupancy',
        occpCls: 'Occupation Class',
        distCls: 'District Class',
        constnCls: 'Construction Class',
        occpClsLim: 'Occupation Class Limit',
        extraRiskLoc: 'Extra Fire Risk Location',
        extraFireRisk: 'Extra Fire Risk Details',
        accmLdgPct: 'Loading %',
        ownTent: 'Owner / Tenant',
        roof: 'Roof Class',
        noStorey: 'No. of Storeys',
        latitude: 'Latitude X',
        longitude: 'Longitude Y',
        survRpt: 'Survey Report No.',
        survDate: 'Survey Date',
        zoneCode: 'Zone',
        siLim: 'Sum Insured Limit'
      },
      fireForm: {
        bldgNo: undefined,
        unitNo: undefined,
        collNo: undefined,
        interest: undefined,
        riskLoc: undefined,
        riskPostCode: undefined,
        occpy: undefined,
        occpCls: undefined,
        distCls: undefined,
        constnCls: undefined,
        occpClsLim: undefined,
        extraRiskLoc: undefined,
        accmLdgPct: undefined,
        ownTent: undefined,
        roof: undefined,
        noStorey: undefined,
        latitude: undefined,
        longitude: undefined,
        survRpt: undefined,
        survDate: undefined,
        occpClsDesc: undefined,
        distClsDesc: undefined,
        constnClsDesc: undefined,
        occpClsLimDesc: undefined,
        zoneCode: undefined,
        zoneCodeDesc: undefined,
        siLim: undefined
      },
      showRiskSurvey: false,
      processing: false
    }
  },
  props: {
    polRisk: Object
  },
  computed: {
    polMaster() {
      return this.$store.state.underwriting.policy.polMaster
    },
    policyQuery() {
      return this.$store.state.underwriting.policyQuerySettings
    },
    riskSurveyMaster() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyMaster
    },
    survRptDetDisabled() {
      if (this.fireForm.survRpt !== undefined && this.fireForm.survRpt !== '') {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('policyQueryInit')])
      if (this.policyQuery.init === 1) {
        this.getPolFireRisk()
      }
    },
    async getPolFireRisk() {
      const apiUrl = this.$store.state.underwriting.policyQuerySettings.menu.polFireRisk
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt,
            riskGrpNo: this.polRisk.riskGrpNo,
            riskNo: this.polRisk.riskNo
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))

          if (result.data.polFireRisk.data) {
            this.fireForm.bldgNo = result.data.polFireRisk.data.bldgNo
            this.fireForm.unitNo = result.data.polFireRisk.data.unitNo
            this.fireForm.collNo = result.data.polFireRisk.data.collNo
            this.fireForm.interest = result.data.polFireRisk.data.interest
            this.fireForm.riskLoc = result.data.polFireRisk.data.riskLoc
            this.fireForm.riskPostCode = result.data.polFireRisk.data.riskPostCode
            this.fireForm.occpy = result.data.polFireRisk.data.occpy
            this.fireForm.occpCls = result.data.polFireRisk.data.occpCls
            this.fireForm.distCls = result.data.polFireRisk.data.distCls
            this.fireForm.constnCls = result.data.polFireRisk.data.constnCls
            this.fireForm.occpClsLim = result.data.polFireRisk.data.occpClsLim
            this.fireForm.extraRiskLoc = result.data.polFireRisk.data.extraRiskLoc
            this.fireForm.accmLdgPct = result.data.polFireRisk.data.accmLdgPct.toFixed(2)
            this.fireForm.ownTent = result.data.polFireRisk.data.ownTent
            this.fireForm.roof = result.data.polFireRisk.data.roof
            this.fireForm.noStorey = result.data.polFireRisk.data.noStorey
            this.fireForm.latitude = result.data.polFireRisk.data.latitude
            this.fireForm.longitude = result.data.polFireRisk.data.longitude
            this.fireForm.survRpt = result.data.polFireRisk.data.survRpt
            this.fireForm.survDate = result.data.polFireRisk.data.survDate
            this.fireForm.occpClsDesc = result.data.polFireRisk.data.occpClsDesc
            this.fireForm.distClsDesc = result.data.polFireRisk.data.distClsDesc
            this.fireForm.constnClsDesc = result.data.polFireRisk.data.constnClsDesc
            this.fireForm.occpClsLimDesc = result.data.polFireRisk.data.occpClsLimDesc
            this.fireForm.zoneCode = result.data.polFireRisk.data.zoneCode
            this.fireForm.zoneCodeDesc = result.data.polFireRisk.data.zoneCodeDesc
            this.fireForm.siLim = formatPrice(result.data.polFireRisk.data.siLim)
          }

          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doQueryRiskSurvey() {
      this.processing = true
      this.$store.commit(RISK_SURVEY_QUERY_MODE)
      const data = {
        item: {
          survNo: this.fireForm.survRpt,
          verCnt: 0,
          polNo: this.polMaster.polNo
        }
      }
      this.$store.dispatch('reviewSurveyMaster', data).then((result) => {
        if (result) {
          const data2 = {
            item: {
              survNo: this.riskSurveyMaster.survNo,
              verCnt: this.riskSurveyMaster.verCnt
            }
          }
          this.$store.dispatch('reviewSurveyDetails', data2).then((result2) => {
            if (result2) {
              this.processing = false
              this.showRiskSurvey = true
            }
          })
        }
      })
    },
    formatDate(xDate) {
      if (xDate === null || xDate === undefined) {
        return undefined
      } else {
        return formatDisplayDate(xDate)
      }
    },
    formatOwnTent(data) {
      if (data === '1') {
        return 'Owner'
      } else {
        return 'Tenant'
      }
    }
  },
  mounted() {
    this.doInit()
  },
  components: {
    RiskSurvey
  },
  mixins: [MessageMixin]
}
</script>

<style lang="scss">
.text-link {
  text-decoration: underline;
}
</style>
